<template>

<el-container>

  <el-header>
    <navbar/>
  </el-header>

  <el-container>

    <sidebar v-if="user" />

    <el-main>
      <child/>
    </el-main>

  </el-container>


  <Footer/>


</el-container>

</template>

<script>
import Navbar from '~/components/Navbar'
import Sidebar from '~/components/Sidebar'
import Footer from '~/components/Footer'

import { mapGetters } from 'vuex'

export default {
  name: 'MainLayout',

  components: {
    Navbar,
    Sidebar,
    Footer
  },

  computed: mapGetters({
    user: 'auth/user'
  }),

}
</script>
<style scoped>
  .el-container {
    height: 100%;
  }
  .el-header {
    padding: 0 !important;
    z-index:11;
  }  
</style>



// WEBPACK FOOTER //
// resources/assets/js/layouts/default.vue